<template>
    <div class="order-step-2__col order-step-2__col-2">
        <div class="order-step-2__col-2-header">
            <h3 class="order-step-2__col-2-heading private">Empfohlene Menge / Woche: {{ totalWeight }} kg</h3>
        </div>
        <div class="order-result-summary__baskets__list private">
            <div
                v-for="(basket, index) in sortedBasketsPeopleMonday"
                :key="`monday-basket-${index}`"
                class="order-result-summary__weight-container"
            >
                <span class="order-result-summary__weight-text">
                    {{ basket.kg }} kg
                </span>
            </div>
            <div
                v-for="(basket, index) in sortedBasketsPeopleWednesday"
                :key="`wednesday-basket-${index}`"
                class="order-result-summary__weight-container"
            >
                <span class="order-result-summary__weight-text">
                    {{ basket.kg }} kg
                </span>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
    computed: {
        ...mapState({
            activeAppetite: state => state.appetite,
            appetites: state => state.orderable.product_groups
                .find(s => s.id === state.subscriptionType).appetites,
        }),
        ...mapGetters([
            'sortedBasketsPeopleMonday',
            'sortedBasketsPeopleWednesday',
        ]),
        totalWeight() {
            return this.sortedBasketsPeopleMonday.reduce((a, b) => a + b.kg, 0) + this.sortedBasketsPeopleWednesday.reduce((a, b) => a + b.kg, 0);
        },
    },
    methods: {
        updateAppetite(name) {
            this.$store.dispatch('updateAppetite', name);
        },
        toggleInfoModalVisible(content) {
            this.$store.commit('toggleInfoModalVisible', content);
        },
    },
};
</script>



// WEBPACK FOOTER //
// AppetitePrivate.vue?4c7bd903